<template>
  <div class="content">
    <div class="c_position">
      <span class="el-icon-location-outline"></span>
      <label>你现在的位置：</label>
      <label>
        <span @click="routerNav()">首页</span>
        <span>>企业文化</span>
        <span>>{{pos}}</span>
      </label>
    </div>
    <div class="profile">
      <div class="p_left">
        <div style="cursor:auto">企业文化</div>
        <div v-for="(item,index) in list" :key="index"  @click="ptext(index)" :class="statuNum == 0 && selfnum==index?'change':'normal'">
          <label>{{item.label}}</label>
        </div>
      </div>
      <div class="p_right">
        <div class="p_type">{{pos}}</div>
        <!-- <div class="p_text" v-html="listtext"> -->
          <div class="p_content">
            <img v-if="pos == '企业文化'" style="width:100%;height: 75%;transform: scale(0.9);" src="@/assets/qiyewenhua.png" alt="" >
            <img v-if="pos == '其他'" style="width:100%;height: 75%;transform: scale(0.9);" :src="listtext" alt="" >

            <div style="padding-left: 48px;" v-if="pos == '企业荣誉'">
              <p style="text-indent:2em;line-height:40px;font-weight:600;">公司必须清醒地看到前进中的困难与挑战，正视自身存在的差距与不足，以更加坚定的信念、更加饱满的热情、更加务实的作风、更加强大的合力，共同谱写公司发展的新篇章，为公司提供强有力的服务与支持。</p>

              <div class="p_image_content">
                <div class="p_type" style="margin-left:0;padding-left:0;">企业证书及资质</div>

                <div class="ziziclass">
                  <el-image 
                    v-for="(item,index) in srcList"
                    :key="index"
                    :style="item.style"
                    :src="item.url" 
                    :preview-src-list="srcList.map(item=>item.url)">
                  </el-image>
                </div>

                <div class="p_type" style="margin-left:0;padding-left:0;">专利及软著</div>


                <div class="zhuanliClass">
                  <div v-for="(item,index) in srcListZhuang" :key="index" style="width: calc(100% / 4);display: flex;justify-content: center;margin: 15px 0;">
                    <el-image 
                      style="width:100%;"
                      z-index="1999"
                      :style="item.style"
                      :src="item.url" 
                      :preview-src-list="srcListZhuang.map(item=>item.url)">
                    </el-image>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      limit: 9,
      total: 0,
      pageNum: 1,
      statuNum: 0,
      selfnum: 0,
      poslist: ["企业文化", "企业荣耀", "其他"],
      pos: "企业文化",
      list: [],
      listtext: [],
      srcList:[
        {url:require('@/assets/ziz1.png'),style:'width:300px;'},
        {url:require('@/assets/ziz2.jpg'),style:'width:300px;margin: 0 50px;'},
        {url:require('@/assets/ziz3.png'),style:'width:200px;'}
      ],
      srcListZhuang:[
        {url:require('@/assets/ruanZhuang/zhuan1.png'),style:'width:150px;'},
        {url:require('@/assets/ruanZhuang/zhuan2.png'),style:'width:150px;'},
        {url:require('@/assets/ruanZhuang/zhuan3.png'),style:'width:150px;'},

        {url:require('@/assets/ruanZhuang/ruan1.jpg'),style:'width:150px;'},
        {url:require('@/assets/ruanZhuang/ruan2.jpg'),style:'width:150px;'},
        {url:require('@/assets/ruanZhuang/ruan3.jpg'),style:'width:150px;'},
        {url:require('@/assets/ruanZhuang/ruan4.jpg'),style:'width:150px;'},
        {url:require('@/assets/ruanZhuang/ruan5.jpg'),style:'width:150px;'},
      ]
    };
  },
  methods: {
    routerNav() {
      this.$router.push({ path: "/home" });
    },
    ptext(num) {
      // console.log(num);
      this.selfnum = num;
      this.pos = this.list[num].label;
      if (this.list[num].articalList != null) {
        this.listtext = this.list[num].articalList[0].body;
      } else {
        this.listtext = [];
      }
      // this.listtext = this.list[num].articalList;
    },
  },
  filters: {
    dataFormat(msg) {
      var rs = msg.slice(0, 10);
      return rs;
    },
    dataShow(msg) {
      if (msg.length >= 40) {
        var res = msg.slice(0, 40) + "...";
        return res;
      } else {
        return msg;
      }
    },
  },
  mounted() {
    window['ptext'] = (num) => {
        this.ptext(num)
    }
    this.list = [
      {
        label:"企业文化",
        articalList:[
          {body:require('@/assets/qiyewenhua.png')}
        ]
      },
      {
        label:"企业荣誉",
        articalList:[
          {body:require('@/assets/fazhan.png')}
        ]
      },
      {
        label:"其他",
        articalList:[
          {body:require('@/assets/qita.jpg')}
        ]
      },
    ]
    var id = window.sessionStorage.getItem("hxdt");
    this.$axios({
      method: "GET",
      url: "/tourist/findColumnByParentIdAndMenuId",
      params: {
        parentId: id,
        menuSign: 1,
      },
    }).then((res) => {
      // console.log(res.data.data);
      
      if (this.list !== []) {
        this.ptext(this.$route.query.num)
      }
    });
  },
};
</script>

<style lang='less' scoped>
.c_position {
  margin-left: 50%;
  transform: translate(-200%);
}
.profile {
  width: 1173px;
  height: 824px;
  // margin-left: 353px;
  // margin:0 20%;
  margin-left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 7px;
  .p_left {
    width: 258px;
    height: 730px;
    border: 1px solid #f6f6f6;
    display: flex;
    flex-direction: column;
    background-color: #fdfdfd;
    div {
      width: 258px;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      label {
        margin-left: 24px;
        margin-top: 20px;
      }
      label:hover {
        cursor: pointer;
      }
    }
    div:hover {
      cursor: pointer;
      background-color: rgba(241, 244, 247, 1);
      color: rgba(19, 71, 121, 1);
    }
    div:nth-child(1) {
      color: white;
      text-align: center;
      font-size: 18px;
      font-weight: 1000;
      background-color: #31689b;
    }
    div:nth-child(1):hover {
      cursor: none;
      background-color: none;
    }
  }
  .p_right {
    height: 824px;
    width: 915px;
    .p_type {
      margin-left: 28px;
      height: 60px;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      color: rgba(49, 104, 155, 1);
      font-size: 18px;
      line-height: 65px;
      font-weight: 1000;
      padding-left: 20px;
    }
    .p_image_content {
      height:500px;
      overflow-y: auto;
      .ziziclass {
        display: flex;
        align-items: center;
      }
      .zhuanliClass {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
      }
    }
    .p_image_content::-webkit-scrollbar {
      display: none;
    }
    .p_text {
      margin-top: 19px;
      height: 744px;
      width: 872px;
      margin-left: 48px;
      span:hover {
        color: #101010;
        cursor:auto;
        text-decoration:none;
      }
      .c_date {
        color: #999ca1;;
        // margin-left:10px;
        margin-left: 10px;
        float: right;
        margin-right: 30px;
      }
    }
  }
  .c_mes2 {
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    width: 872px;
    height: 600px;
    border: none;
    ul {
      li {
        font-size: 16px;
        margin: 0px;
        border-bottom: 1px dashed #e9e9e9;
        height: 60px;
        padding: 0px;
        line-height: 60px;
      }
    }
    .first_text{
      &:hover{
        cursor: pointer !important;
        text-decoration: underline !important;
      }
    }
  }
}
</style>
<style lang="less">
p {
  //text-indent: 1cm;
}
.c_position {
  width: 290px;
  height: 21px;
  display: flex;
  flex-direction: row;
  color: #989aa0;
  margin-top: 10px;

  span {
    width: 22px;
    height: 22px;
  }
  label {
    font-size: 12px;
  }
  label:nth-child(1) {
    margin-left: 1px;
  }
}
.block {
  margin-left: 240px;
  margin-top: 32px;
}
</style>